module.exports = __webpack_public_path__ + "static/media/home_active.f31a8fa5.png";